import { Badge } from '../components/ui/badge';
import { formatDate } from '../utils/dateFormat';

export function DispatchEntriesTable({ entries }) {
  if (!entries || entries.length === 0) {
    return <p className="text-sm text-zinc-400">No dispatch entries yet</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className="border-b border-zinc-200 bg-zinc-50">
            <th className="p-2 text-left font-bold text-zinc-500">#</th>
            <th className="p-2 text-left font-bold text-zinc-500">Date</th>
            <th className="p-2 text-left font-bold text-zinc-500">Driver</th>
            <th className="p-2 text-left font-bold text-zinc-500">Contact</th>
            <th className="p-2 text-left font-bold text-zinc-500">Vehicle</th>
            <th className="p-2 text-left font-bold text-zinc-500">Type</th>
            <th className="p-2 text-left font-bold text-zinc-500">Remarks</th>
          </tr>
        </thead>
        <tbody>
          {entries.map(entry => (
            <tr key={entry.entry_number} className="border-b border-zinc-100">
              <td className="p-2 font-bold">{entry.entry_number}</td>
              <td className="p-2">{formatDate(entry.dispatch_date) || entry.dispatch_date}</td>
              <td className="p-2">{entry.driver_name}</td>
              <td className="p-2">{entry.driver_contact}</td>
              <td className="p-2">{entry.vehicle_number}</td>
              <td className="p-2">
                <Badge className={entry.dispatch_type === 'full' ? 'bg-emerald-100 text-emerald-700' : 'bg-orange-100 text-orange-700'}>
                  {entry.dispatch_type}
                </Badge>
              </td>
              <td className="p-2 text-zinc-500">{entry.remarks || '--'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
